module.exports = __webpack_public_path__ + "static/img/p1-t12.b0357af.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-t12.png
// module id = c+ai
// module chunks = 0